let featuredEventsIds = process.env.VUE_APP_FEATURED_EVENTS_IDS || "";

featuredEventsIds
  .split(",")
  .forEach((id, index, array) => (array[index] = parseInt(id.trim())));

export default featuredEventsIds;
